import { Info } from 'lucide-react';
import type { ReactNode } from 'react';
import { useT } from '../lib/i18n.tsx';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover.tsx';

/**
 * An info button that opens an explanation. A popover rather than a hover tooltip: it works with
 * the keyboard and on touch screens, where hover does not exist.
 */
export function InfoPopover({ label, children }: { label: string; children: ReactNode }) {
  const t = useT();
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={`${t.common.info}: ${label}`}
          className="inline-flex size-6 shrink-0 items-center justify-center rounded-full text-muted-foreground hover:bg-muted hover:text-foreground"
        >
          <Info aria-hidden="true" className="size-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent>{children}</PopoverContent>
    </Popover>
  );
}
